import React from 'react';
import { Link } from 'react-router-dom';
import { BLOGS } from '../data/mockContent';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      {/* Editorial Hero Section */}
      <header className="hero-section">
        <h1>Engineering the Future of<br/>AI Infrastructure</h1>
        <p>
          Deep dives into architecting autonomous agents, scalable inference systems, 
          and production-grade machine learning pipelines.
        </p>
      </header>

      {/* Grid Section Label */}
      <div className="section-label">
        <span>System Architecture Series</span>
      </div>

      <div className="blog-grid">
        {BLOGS.map((blog) => (
          <article key={blog.id} className="blog-card">
            <div className="card-body">
              <div className="tags">
                {blog.tags.map(tag => <span key={tag} className="tag">{tag}</span>)}
              </div>
              <h2 className="card-title">{blog.title}</h2>
              <p className="card-excerpt">{blog.excerpt}</p>
              
              <div className="card-footer">
                <span className="author">{blog.author}</span>
                <span className="date">{new Date(blog.date).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}</span>
              </div>
              
              <br/>

              <Link to={`/blog/${blog.id}`} className="read-more-link">
                Access Protocol
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Home;
